import { getCookie, setCookie } from "cookies-next";
import { v4 as uuidv4 } from "uuid";

function randomString(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// eslint-disable-next-line import/prefer-default-export
export function manageTrackingId() {
  let trackingId = getCookie("trackingId");

  if (!trackingId) {
    const today = new Date();
    const oneWeekFromToday = new Date(today);
    oneWeekFromToday.setDate(today.getDate() + 7);

    trackingId = uuidv4() + randomString(5);
    setCookie("trackingId", trackingId, { expires: oneWeekFromToday });
  }

  return trackingId;
}

// eslint-disable-next-line import/prefer-default-export
export function manageSessionId() {
  let sessionId = getCookie("sessionId");

  if (!sessionId) {
    sessionId = uuidv4() + randomString(5);
    setCookie("sessionId", sessionId);
  }

  return sessionId;
}

export function manageThaId() {
  // Check if tha cookie already exists
  let thaId = getCookie("tha");

  if (!thaId) {
    // Check for tha query parameter
    if (typeof window !== "undefined") {
      const urlParams = new URLSearchParams(window.location.search);
      thaId = urlParams.get("tha");

      if (thaId) {
        // Set cookie with 1 year expiration
        const today = new Date();
        const oneYearFromToday = new Date(today);
        oneYearFromToday.setFullYear(today.getFullYear() + 1);
        setCookie("tha", thaId, { expires: oneYearFromToday });
      }
    }
  }

  return thaId;
}

export async function updateLastActivity(talentHubAccountId) {
  if (!talentHubAccountId) {
    return;
  }

  const talenthubApiUrl = process.env.TALENTHUB_API_URL;
  if (!talenthubApiUrl) {
    console.warn("TALENTHUB_API_URL is not configured");
    return;
  }

  try {
    const url = `${talenthubApiUrl}/account/update-last-activity?talentHubAccountId=${encodeURIComponent(
      talentHubAccountId
    )}&type=CAREERS_SITE`;

    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    console.error("Failed to update last activity:", error);
  }
}
